import {Component, Input} from '@angular/core';

@Component({
    selector: 'ui-kit-error-panel',
    templateUrl: './error-panel.component.html',
    standalone: false
})
export class ErrorPanelComponent {
    @Input() errorWarningPanelTitle: string = 'i18n_lib_commonErrorWarningPanelTitle';
    @Input() color: 'red' | 'yellow';

    get errorClass(): string {
        return this.color === 'yellow'
            ? 'c-secondary-yellow-900'
            : 'c-secondary-red-800';
    }
}
